import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion'

const About = () => {

    return (
        <>

            <h1 className="title">
                <Link to="/">Web3</Link>
            </h1>

            <motion.div className="container About"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >

                <main className="main">

                    <div className="page-content">

                        <h2 className="h2">LOL</h2>
                        <p className="description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                        <h2 className="h2">LOL</h2>
                        <p className="description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>

                    </div>

                </main>

            </motion.div>
        </>

    );
};

export default About